module.exports = __webpack_public_path__ + "assets/img/index-partner25.6713ad8e.jpg";